function filter() {
    const mixitup = require('mixitup');

    // var mixer = mixitup('.filter-container');
    var containerEl = $('.filter-container');
    var mixer = mixitup(containerEl, {
        load: {
            sort: 'published-date:desc'
        }
    });
}

if ($('.filter-container').length) {
    filter();
    $('.group-btn-filter .btn-filter').click(function() {
        $(this).addClass('filter-active').siblings().removeClass('filter-active');
    });
    $('.group-btn-filter .btn-sort').click(function() {
        // $(this).addClass('sort-active').siblings().removeClass('sort-active');
        $(this).removeClass('sort-active').addClass('hide-toggle').siblings().addClass('sort-active').removeClass('hide-toggle');
    });
}
